import React from 'react'
import styled from 'styled-components'

const SVG = styled.svg`
  border-radius: 50%;
  cursor: ${p => (p.disabled ? 'not-allowed' : 'pointer')};
  transform: ${p => (p.rotatedeg ? `rotate(${p.rotatedeg})` : 'rotate(0deg)')};
  background-color: #ececec;
  width: ${p => (p.width ? p.width : '40px')};
  height: ${p => (p.height ? p.height : '40px')};
  padding: 5px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${p =>
      p.disabled ? '#ececec' : 'var(--brand-green-color)'};
  }

  .cls-1 {
    fill: #033a6e;
  }

  .cls-1,
  .cls-2 {
    stroke-width: 0px;
  }

  .cls-3 {
    fill: none;
    stroke: gray;
    stroke-miterlimit: 10;
  }

  .cls-2 {
    fill: #d6d6d6;
  }

  &:hover {
    .cls-2 {
      fill: ${p => (p.disabled ? 'var(--grey)' : 'var(--brand-green-color)')};
    }
  }

  @media (max-width: 575px) {
    width: 28px;
    height: 28px;
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 850px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
    width: 20px;
    height: 20px;
    padding: 2px;
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 850px) and (min--moz-device-pixel-ratio: 2) and (orientation: landscape) {
    width: 20px;
    height: 20px;
    padding: 2px;
  }
`

export default function Arrow({
  width,
  height,
  rotateDeg = '0deg',
  onClick,
  disabled,
}) {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -960 960 960"
      width={width}
      height={height}
      rotatedeg={rotateDeg}
      onClick={onClick}
      disabled={disabled}
    >
      <g id="assets">
        <g id="bg">
          <circle className="cls-2" cx="14.5" cy="14.5" r="14" />
          <circle className="cls-3" cx="14.5" cy="14.5" r="14" />
        </g>
        {!disabled && (
          <path
            className="cls-1"
            d="M412-846v470L210-577l-96 97 366 366 366-366-96-98-202 202v-470H412Z"
          />
        )}
      </g>
    </SVG>
  )
}
